(() => {
  const isGerman = () => (document.documentElement.lang || '').toLowerCase().startsWith('de');
  if (!isGerman()) return;

  const normalize = value => String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

  const exact = new Map(Object.entries({
    'RETOURNEREN': 'RÜCKGABE & UMTAUSCH',
    'Retourneren': 'RÜCKGABE & UMTAUSCH',
    'HERROEPING': 'WIDERRUFSRECHT',
    'Herroeping': 'WIDERRUFSRECHT',
    'Gebruik het onderstaande formulier om uw herroeping in te dienen.': 'Fülle das folgende Formular aus, um deinen Widerruf einzureichen.',
    'Gebruik het onderstaande formulier om uw herroeping in te dienen': 'Fülle das folgende Formular aus, um deinen Widerruf einzureichen.',
    'Füllen Sie das folgende Formular aus, um Ihren Widerrufsantrag einzureichen.': 'Fülle das folgende Formular aus, um deinen Widerruf einzureichen.',
    'Voer uw bestelnummer en e-mailadres of telefoonnummer in om uw bestelling te vinden.': 'Gib deine Bestellnummer und deine E-Mail-Adresse oder Telefonnummer ein, um deine Bestellung zu finden.',
    'Voer uw bestelnummer en e-mailadres of telefoonnummer in om uw bestelling te vinden': 'Gib deine Bestellnummer und deine E-Mail-Adresse oder Telefonnummer ein, um deine Bestellung zu finden.',
    'Bestelnummer': 'Bestellnummer',
    'E-mailadres of Telefoonnummer': 'E-Mail-Adresse oder Telefonnummer',
    'E-mailadres of telefoonnummer': 'E-Mail-Adresse oder Telefonnummer',
    'VIND JE BESTELLING': 'BESTELLUNG FINDEN',
    'Vind je bestelling': 'Bestellung finden',
    'Totale lengte': 'Gesamtlänge',
    'Totale Lengte': 'Gesamtlänge',
    'Totale lengte (cm)': 'Gesamtlänge (cm)',
    'Borst': 'Brustweite',
    'Borstbreedte': 'Brustweite',
    'Borstomvang': 'Brustumfang',
    'Mouw': 'Ärmellänge',
    'Mouwlengte': 'Ärmellänge',
    'Schouder': 'Schulterbreite',
    'Schouderbreedte': 'Schulterbreite',
    'Taille': 'Taillenweite',
    'Heup': 'Hüftweite',
    'Binnenbeenlengte': 'Innenbeinlänge',
    'Buitenbeenlengte': 'Außenbeinlänge',
    'One Size- past iedereen.': 'Einheitsgröße, passend für die meisten Kopfformen.',
    'One Size - past iedereen.': 'Einheitsgröße, passend für die meisten Kopfformen.',
    'Belangrijkste kenmerken:': 'Details:',
    'Kenmerken:': 'Details:',
    'DRAAG WAT JE LEEFT': 'TRAG, WAS DU LEBST',
    'Van stadion tot kroeg.': 'Vom Stadion bis zur Kneipe.',
    'VAN STADION TOT KROEG': 'VOM STADION BIS ZUR KNEIPE',
    'HOSEN & SHORTS': 'SHORTS & HOSEN',
    'Hosen & Shorts': 'SHORTS & HOSEN',
    'JEANS & SHORTS': 'SHORTS & HOSEN',
    'Jeans & Shorts': 'SHORTS & HOSEN',
    'BROEKEN & SHORTS': 'SHORTS & HOSEN',
    'ZUBEHÖR': 'ACCESSOIRES',
    'Zubehör': 'ACCESSOIRES',
    'ZUBEHOR': 'ACCESSOIRES',
    'Accessoires': 'ACCESSOIRES'
  }));

  const menu = new Map(Object.entries({
    'SHOP ALLES': 'ALLE PRODUKTE',
    'ALLE PRODUKTE': 'ALLE PRODUKTE',
    'T-SHIRTS': 'T-SHIRTS',
    'SWEATERS & HOODIES': 'SWEATSHIRTS & HOODIES',
    'SWEATSHIRTS & HOODIES': 'SWEATSHIRTS & HOODIES',
    'JEANS & SHORTS': 'SHORTS & HOSEN',
    'BROEKEN & SHORTS': 'SHORTS & HOSEN',
    'HOSEN & SHORTS': 'SHORTS & HOSEN',
    'SHORTS UND HOSEN': 'SHORTS & HOSEN',
    'SHORTS & HOSEN': 'SHORTS & HOSEN',
    'JASSEN': 'JACKEN',
    'JACKEN': 'JACKEN',
    'ZUBEHÖR': 'ACCESSOIRES',
    'ZUBEHOR': 'ACCESSOIRES',
    'ACCESSOIRES': 'ACCESSOIRES',
    'SALE': 'SALE',
    'OVER ONS': 'ÜBER UNS',
    'ÜBER UNS': 'ÜBER UNS',
    'CONTACT': 'KONTAKT',
    'KONTAKT': 'KONTAKT',
    'RETOURNEREN': 'RÜCKGABE & UMTAUSCH',
    'RÜCKGABE': 'RÜCKGABE & UMTAUSCH',
    'RÜCKGABE UND UMTAUSCH': 'RÜCKGABE & UMTAUSCH',
    'RÜCKGABE & UMTAUSCH': 'RÜCKGABE & UMTAUSCH',
    'HERROEPING': 'WIDERRUFSRECHT',
    'WIDERRUF': 'WIDERRUFSRECHT',
    'WIDERRUFSRECHT': 'WIDERRUFSRECHT',
    'COLLECTIES': 'KOLLEKTIONEN',
    'KOLLEKTIONEN': 'KOLLEKTIONEN',
    'SPORTSHIRTS': 'SPORTSHIRTS',
    'T-SHIRTS & POLO’S': 'T-SHIRTS & POLOS',
    'T-SHIRTS & POLOS': 'T-SHIRTS & POLOS',
    'SWEATERS & VESTEN': 'SWEATSHIRTS & ZIP-HOODIES'
  }));

  const colors = new Map(Object.entries({
    'zwart': 'Schwarz', 'wit': 'Weiß', 'grijs': 'Grau', 'donkergrijs': 'Dunkelgrau',
    'lichtgrijs': 'Hellgrau', 'blauw': 'Blau', 'donkerblauw': 'Dunkelblau',
    'lichtblauw': 'Hellblau', 'marineblauw': 'Marineblau', 'groen': 'Grün',
    'donkergroen': 'Dunkelgrün', 'lichtgroen': 'Hellgrün', 'olijfgroen': 'Olivgrün',
    'rood': 'Rot', 'bordeauxrood': 'Bordeauxrot', 'bordeaux': 'Bordeaux',
    'bruin': 'Braun', 'beige': 'Beige', 'zand': 'Sand', 'crème': 'Creme',
    'creme': 'Creme', 'geel': 'Gelb', 'oranje': 'Orange', 'roze': 'Rosa',
    'paars': 'Lila', 'zwart/wit': 'Schwarz/Weiß', 'wit/zwart': 'Weiß/Schwarz',
    'blauw/wit': 'Blau/Weiß', 'groen/wit': 'Grün/Weiß'
  }));

  const phrasePairs = [
    ['Wil je een retour starten, vul dan het onderstaande formulier in of mail naar', 'Möchtest du eine Rückgabe oder einen Umtausch anmelden, fülle das Formular unten aus oder schreib uns an'],
    ['Ruilen voor een andere maat of een ander product is kosteloos mogelijk. In dat geval nemen wij de kosten van het retourlabel en de verzending van het nieuwe product voor onze rekening.', 'Der Umtausch in eine andere Größe oder gegen einen anderen Artikel ist kostenlos. Wir übernehmen das Rücksendeetikett und den Versand des Ersatzartikels.'],
    ['Wij nemen de retouraanvraag binnen 1 tot 2 werkdagen in behandeling. Vervolgens ontvang je van ons een link om het retourlabel aan te schaffen. Daarna ontvang je het retourlabel in je mailbox.', 'Wir bearbeiten deine Anfrage innerhalb von 1 bis 2 Werktagen. Danach erhältst du per E-Mail alle weiteren Schritte und, falls nötig, dein Rücksendeetikett.'],
    ['Retourneren is op eigen kosten. De retourkosten bedragen 6,95.', 'Bei einer reinen Rückgabe trägst du die Rücksendekosten von 6,95 €.'],
    ['Vul het formulier in met de volgende gegevens om een retour of omruiling te starten :', 'Gib im Formular folgende Angaben an:'],
    ['- NAAM', '- NAME'], ['- E-MAIL', '- E-MAIL-ADRESSE'], ['- TELEFOONNUMMER', '- TELEFONNUMMER'],
    ['- REACTIE : Je ordernummer, de keuze voor retourneren of ruilen en je reden voor retour.', '- NACHRICHT: Bestellnummer, Rückgabe oder Umtausch und Rückgabegrund.'],
    ['De perfecte keuze als je op zoek bent naar een praktische en stijlvol vest. Gemaakt van hoogwaardige materialen met lichte isolatie, biedt dit vest zowel comfort als bescherming tegen de kou.', 'Das leichte Tracktop verbindet cleanen Casual Style mit hohem Tragekomfort. Die hochwertige Materialmischung sorgt für angenehme Wärme, ohne schwer zu wirken. Ideal für Stadion, Stadt und Alltag.'],
    ['De perfecte keuze als je op zoek bent naar een praktische en stijlvolle korte broek. Gemaakt van hoogwaardige materialen met lichte isolatie, bieden deze shorts zowel comfort als bescherming tegen de warmte.', 'Die Sportshort verbindet einen cleanen Casual Look mit leichtem Tragekomfort. Das hochwertige Polyester ist angenehm zu tragen und ideal für warme Tage, Training und Alltag.'],
    ['De perfecte keuze als je op zoek bent naar een praktische en stijlvol T-Shirt. Gemaakt van hoogwaardige materialen met lichte isolatie, biedt dit T-Shirt zowel comfort als bescherming in verschillenden weersomstandigheden.', 'Dieses T-Shirt verbindet einen klaren Chevalier Look mit einer bequemen Passform. Das hochwertige Material fühlt sich angenehm an und eignet sich für Stadion, Stadt und Alltag.'],
    ['De perfecte keuze als je op zoek bent naar een casual stijlvol oversized T-Shirt. Gemaakt van hoogwaardige materialen met lichte isolatie, biedt dit T-Shirt zowel comfort als bescherming in verschillenden weersomstandigheden.', 'Das Oversized T-Shirt verbindet eine entspannte Passform mit einem klaren Chevalier Look. Das hochwertige Material fällt sauber, fühlt sich angenehm an und ist für jeden Tag gemacht.'],
    ['De perfecte keuze als je op zoek bent naar een praktische en stijlvolle korte spijkerbroek. Gemaakt van hoogwaardige materialen met lichte isolatie, bieden deze denim shorts zowel comfort als bescherming tegen de warmte.', 'Die Denim Shorts verbinden einen cleanen Casual Look mit einer bequemen Passform. Der hochwertige Denim ist robust, angenehm zu tragen und ideal für warme Tage.'],
    ['De perfecte keuze voor elke buitenactiviteit, deze pet combineert comfort en bescherming tegen de elementen. Gemaakt van hoogwaardige materialen, bied hij uitstekende warmte, ademend vermogen en weerbestendigheid.', 'Die Classic Cap verbindet einen cleanen Look mit funktionalem Komfort. Das hochwertige Material schützt bei wechselhaftem Wetter und bleibt angenehm atmungsaktiv.'],
    ['Gemaakt van hoogwaardig nylon met ademende mesh voering. Licht, waterafstotend en winddicht. Ontworpen voor maximaal draagcomfort, zowel op de tribune als in het dagelijks leven.', 'Gefertigt aus hochwertigem Nylon mit atmungsaktivem Mesh-Futter. Leicht, wasserabweisend und winddicht. Entwickelt für maximalen Komfort, auf der Tribüne und im Alltag.'],
    ['Hoogwaardige voering – Ideaal voor wisselende weersomstandigheden.', 'Leicht gefüttert, ideal für wechselhaftes Wetter.'],
    ['Chevalier logo en tekst borduring - voor een stijlvolle uitstraling.', 'Gesticktes Chevalier Logo und Schriftzug.'],
    ['Katoen / Polyester mix - perfect voor dagelijks gebruik.', 'Baumwoll-Polyester-Mix für Komfort und Formbeständigkeit.'],
    ['Hoogwaardig polyester materiaal – Ideaal voor wisselende weersomstandigheden.', 'Hochwertiges, leichtes Polyester.'],
    ['Geborduurde Chevalier logo’s - voor een stijlvolle uitstraling.', 'Gestickte Chevalier Logos.'],
    ['Perfecte pasvorm - voor een comfortabele en veelzijdige look, perfect voor dagelijks gebruik.', 'Bequeme Passform für einen vielseitigen Look.'],
    ['Premium materiaal – Ideaal voor elke weersomstandigheid.', 'Hochwertiges Material mit angenehmem Tragegefühl.'],
    ['Guardian bedrukking - voor een stijlvolle uitstraling.', 'Hochwertiger Guardian Print.'],
    ['Classic bedrukking - voor een stijlvolle uitstraling.', 'Hochwertiger Classic Print.'],
    ['Hoogwaardige bedrukking - voor een stijlvolle uitstraling.', 'Hochwertiger Print.'],
    ['Perfecte fit - voor een comfortabele en veelzijdige look, perfect voor dagelijks gebruik.', 'Bequemer Fit für Stadion, Stadt und Alltag.'],
    ['Hoogwaardig materiaal – Ideaal voor wisselende weersomstandigheden.', 'Hochwertiges, robustes Material.'],
    ['Geborduurde Chevalier patch - voor een stijlvolle uitstraling.', 'Gestickter Chevalier Patch.'],
    ['Waterafstotend en winddicht – Ideaal voor uitdagende weersomstandigheden.', 'Wasserabweisend und windresistent.'],
    ['Elastische band - Voor een perfecte pasvorm en optimale bewegingsvrijheid.', 'Elastischer Einsatz für eine bequeme Passform.'],
    ['Ademend materiaal - Zorgt ervoor dat je hoofd comfortabel blijft, ongeacht de intensiteit van je activiteit.', 'Atmungsaktives Material für hohen Tragekomfort.'],
    ['Waterafstotend & winddicht', 'Wasserabweisend & winddicht'],
    ['Premium geborduurde Chevalier patch', 'Hochwertig gestickter Chevalier Patch'],
    ['Zijzakken met rits', 'Seitentaschen mit Reißverschluss']
  ];

  function modelCopy(value) {
    return value
      .replace(/Model is\s*(\d+)\s*CM\s*,\s*(\d+)\s*KG\s*en draagt maat\s*([A-Z0-9]+)/gi, 'Das Model ist $1 cm groß, wiegt $2 kg und trägt Größe $3')
      .replace(/Model is\s*(\d+)\s*cm\s*,\s*(\d+)\s*kg\s*en draagt maat\s*([A-Z0-9]+)\.?/gi, 'Das Model ist $1 cm groß, wiegt $2 kg und trägt Größe $3.');
  }

  function professionalTranslate(value) {
    const original = normalize(value);
    if (!original) return value;
    if (exact.has(original)) return exact.get(original);
    let output = modelCopy(value);
    phrasePairs.forEach(([from, to]) => { output = output.split(from).join(to); });
    return output;
  }

  function translateTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.parentElement) return;
    if (node.parentElement.closest('script, style, noscript, textarea, [data-chevalier-no-translate]')) return;
    const result = professionalTranslate(node.nodeValue);
    if (result !== node.nodeValue) node.nodeValue = result;
  }

  function translateAttributes(root = document) {
    root.querySelectorAll?.('[placeholder], [title], [aria-label]').forEach(element => {
      ['placeholder', 'title', 'aria-label'].forEach(attribute => {
        if (!element.hasAttribute(attribute)) return;
        const current = element.getAttribute(attribute);
        const translated = professionalTranslate(current);
        if (translated !== current) element.setAttribute(attribute, translated);
      });
    });
  }

  function walk(root = document.body) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) return translateTextNode(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(translateTextNode);
    translateAttributes(root.nodeType === Node.DOCUMENT_NODE ? root : root);
  }

  function enforceMenus(root = document) {
    const selector = [
      '.menu-drawer__menu-item-text', '.menu-list__link-title', '.menu__heading__default',
      'header nav a', 'footer nav a', '.header__menu-item', '.footer-block__details-content a'
    ].join(',');
    root.querySelectorAll?.(selector).forEach(element => {
      const key = normalize(element.textContent).toUpperCase();
      const mapped = menu.get(key);
      if (mapped && normalize(element.textContent) !== mapped) element.textContent = mapped;
      element.style.textTransform = 'uppercase';
    });
  }

  function colorContext(element) {
    const container = element.closest('.variant-option, fieldset, [data-option-name], [class*="swatch"], [class*="variant"]');
    if (!container) return false;
    const label = normalize(container.querySelector('legend, label, [class*="label"]')?.textContent || container.getAttribute('data-option-name'));
    return /^(kleur|color|colour|farbe)\b/i.test(label) || /\b(farbe|kleur)\b/i.test(label);
  }

  function translateColors(root = document) {
    const selector = '.variant-option__swatch-value, .variant-option__button-label__text, .variant-option__select option, .chev-linked-swatches__current, [class*="swatch"] [class*="value"], [data-option-value]';
    root.querySelectorAll?.(selector).forEach(element => {
      if (!colorContext(element)) return;
      const key = normalize(element.textContent).toLowerCase();
      if (colors.has(key)) element.textContent = colors.get(key);
      if (element.hasAttribute('aria-label')) {
        const ariaKey = normalize(element.getAttribute('aria-label')).toLowerCase();
        if (colors.has(ariaKey)) element.setAttribute('aria-label', colors.get(ariaKey));
      }
    });
    root.querySelectorAll?.('.variant-option input[aria-label]').forEach(input => {
      if (!colorContext(input)) return;
      const key = normalize(input.getAttribute('aria-label')).toLowerCase();
      if (colors.has(key)) input.setAttribute('aria-label', colors.get(key));
    });
  }

  function hideGermanBrandBanner() {
    if (!location.pathname.includes('/products/')) return;
    const candidates = [
      ...document.querySelectorAll('img[src*="ZOMERCOLLECTIE_a3b75828-ddf4-435e-8b0e-1d80df22aafc"]'),
      ...document.querySelectorAll('[id*="image_Nw9qtq"] img, [id*="image_r4QjtM"] img')
    ];
    [...new Set(candidates)].forEach(image => {
      const wrapper = image.closest('figure, .image-block, [class*="image-block"], [class*="media"]') || image.parentElement;
      if (!wrapper) return;
      wrapper.style.setProperty('display', 'none', 'important');
      wrapper.setAttribute('aria-hidden', 'true');
      wrapper.dataset.chevalierGermanBannerHidden = 'true';
    });
  }

  function translateShadowRoots(root = document) {
    root.querySelectorAll?.('*').forEach(element => {
      if (element.shadowRoot) enhance(element.shadowRoot);
    });
  }

  function translateSameOriginFrames() {
    document.querySelectorAll('iframe').forEach(frame => {
      try {
        const doc = frame.contentDocument;
        if (doc?.body) enhance(doc);
      } catch (_) {}
    });
  }

  function enhance(root = document) {
    walk(root.body || root);
    enforceMenus(root);
    translateColors(root);
    hideGermanBrandBanner();
    translateShadowRoots(root);
  }

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhance(document);
      translateSameOriginFrames();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();

  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true, childList: true, characterData: true, attributes: true,
    attributeFilter: ['placeholder', 'title', 'aria-label']
  });
  window.addEventListener('load', schedule, { once: true });
  setTimeout(schedule, 500);
  setTimeout(schedule, 1500);
  setTimeout(schedule, 3500);
})();
